import { localize } from '../i18n';
import { displaySkipReason } from '../utils/skipReasonCopy';
import React, { useId, useState } from 'react';
import { Box, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import BottomSheet from './BottomSheet';
import Button from './ui/FitButton';
import SingleLineText from './ui/SingleLineText';
import { colors, sheetSpacing } from '../design/tokens';

export default function SkipReasonDetails({ log }) {
    const [open, setOpen] = useState(false);
    const titleId = useId();
    const reason = log?.skipReason;
    if (log?.status !== 'SKIPPED' || typeof reason !== 'string' || !reason.trim()) return null;
    const displayedReason = displaySkipReason(reason);

    return <>
        <Box component="button" type="button" data-skip-reason
            aria-label={localize("{v0} 건너뛴 사유 보기", { v0: log.medicationName })}
            onClick={() => setOpen(true)} sx={{
                display: 'flex', alignItems: 'center', gap: 1, width: '100%', minHeight: 48,
                p: 0, border: 0, bgcolor: 'transparent', cursor: 'pointer',
                fontFamily: 'inherit', textAlign: 'left', color: colors.textSecondary,
                '&:active': { opacity: 0.7 },
                '&:focus-visible': { outline: `2px solid ${colors.brandDark}`, outlineOffset: 2, borderRadius: 1 },
            }}>
            <SingleLineText component="span" sx={{ fontSize: '0.875rem', flexShrink: 0 }}>{localize("사유:")}</SingleLineText>
            <Typography component="span" sx={{ flex: 1, minWidth: 0, fontSize: '0.875rem',
                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {displayedReason.replace(/\s+/g, ' ').trim()}
            </Typography>
            <ChevronRightIcon sx={{ fontSize: 18, flexShrink: 0 }} />
        </Box>
        <BottomSheet open={open} onClose={() => setOpen(false)} ariaLabelledBy={titleId}
            footer={<Button fullWidth variant="contained" disableElevation onClick={() => setOpen(false)}
                sx={{ bgcolor: colors.brand, color: colors.brandText, borderRadius: 3,
                    py: 1.5, fontSize: '1.1rem', fontWeight: 700,
                    '&:hover': { bgcolor: colors.brandHover } }}>{localize("확인")}</Button>}>
            <SingleLineText id={titleId} component="h2" sx={{ fontSize: '1.25rem', fontWeight: 700, mb: sheetSpacing.section }}>{localize("건너뛴 사유")}</SingleLineText>
            <Typography sx={{ fontSize: '1rem', fontWeight: 600, overflowWrap: 'anywhere' }}>{log.medicationName}</Typography>
            <SingleLineText sx={{ mt: 0.5, fontSize: '0.875rem', color: colors.textSecondary }}>{localize("복용 예정 ")}{log.scheduledDate?.replace(/-/g, '.')} {log.scheduledTime?.slice(0, 5)}
            </SingleLineText>
            <Typography data-skip-reason-full sx={{ mt: sheetSpacing.section, fontSize: '1rem', lineHeight: 1.6,
                whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{displayedReason}</Typography>
        </BottomSheet>
    </>;
}
